import {Component, inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';

import {SafeUrl} from "@angular/platform-browser";
import {Subscription} from "rxjs";
import {isDefined, notDefined, unsubscribe} from "../../utils/epic.utils";
import {MediaService} from "../../../services/media/media.service";

@Component({
  selector: 'acc-media',
  imports: [],
  templateUrl: './media.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './media.component.css'
})
export class MediaComponent implements OnInit, OnDestroy, OnChanges {

  @Input({required: true})
  public mediaId: string | undefined;

  @Input()
  public name: string | undefined;

  @Input()
  public alt: string | undefined;

  @Input()
  public maxHeight: string | undefined;

  @Input()
  public maxWidth: string | undefined;

  protected imageUrl: SafeUrl | undefined;

  private readonly mediaService: MediaService = inject(MediaService);

  private readonly subs: Subscription[] = [];

  ngOnInit(): void {
    if (isDefined(this.mediaId) && notDefined(this.imageUrl)) {
      this.loadImageContent(this.mediaId);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['mediaId'] && !changes['mediaId'].firstChange && isDefined(this.mediaId)) {
      this.loadImageContent(this.mediaId);
    }
  }

  ngOnDestroy(): void {
    unsubscribe(this.subs);
  }

  private loadImageContent(mediaId: string): void {
    this.subs.push(this.mediaService.loadImageContent(mediaId).subscribe((res) => this.imageUrl = res));
  }
}
